/**
 * @author sai shiva
 * @Date: 2022-03-03 16:15:15
 * @Last Modified by: sai shiva
 * @Last Modified time: 2022-03-03 18:25:30
 */

import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { bool } from 'prop-types';
import { Row, Col } from 'antd';
import StyledPropelCorporateGifting from './StyledPropelCorporateGifting';
import endPoints from '../../../config/endPoints';
import { HeaderContainer } from '../../HeaderContainer/Loadable';
import { constants } from '../../../devUtils';
import { Loader, Container } from '../../../components';
import { IMG_IMPORTS } from '../../../devUtils/assests';

class PropelCorporateGifting extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.hideLoader();
  }

  componentWillUnmount() {
  }

  hideLoader() {
    const proc = new Promise((resolve) => {
      setTimeout(() => resolve(), 20);
    });
    proc.then(() => this.setState({ isLoading: false }));
  }

  render() {
    const { isHideHeader } = this.props;
    const { isLoading } = this.state;
    if (isLoading) {
      return <Loader />;
    }
    return (
      <StyledPropelCorporateGifting>
        {!isHideHeader ? <HeaderContainer location={this.props} /> : ''}
        <nav className="nav-propel-corp-gift">
          <Container>
            <Row align="middle" type="flex" justify="start">
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Link to={constants.LINK_PROPEL} target="_blank">
                  <img
                    src={endPoints.PROPEL_LOGO.URL}
                    alt={endPoints.PROPEL_LOGO.ALT}
                    className="propel-logo"
                  />
                </Link>
              </Col>
              <Col className="btn-right" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Link to={constants.LINK_CONTACTUS} className="btn red-btn">CONTACT US</Link>
              </Col>
            </Row>
          </Container>
          <img src={IMG_IMPORTS.XMAS_SANTA.URL} alt={IMG_IMPORTS.XMAS_SANTA.ALT} className="xmas-santa" />
        </nav>
        <section className="padding-t-4">
          <Container>
            <Row align="middle" type="flex" justify="start" className="propel-corp-gifts">
              <Col xs={24} sm={24} md={9} lg={9} xl={9} className="highlight-theme">
                <h2>On this Christmas & New Year</h2>
                <h1 className="corp-gift-headline">Create moments <br />of delight</h1>
                <h2 className="font-30">for your employees and channel partners</h2>
                <hr className="hr-line" />
                <Link to={constants.LINK_PROPEL_CORPORATE_GIFITING_HOME} className="btn red-btn margin-b-2 margin-t-1">EXPLORE</Link>
                <h2>to enjoy the <strong className="color-red">Corporate Gifting</strong> benefits</h2>
                <img src={IMG_IMPORTS.XMAS_TREE.URL} alt={IMG_IMPORTS.XMAS_TREE.ALT} className="width-9" />
              </Col>
              <Col xs={24} sm={24} md={15} lg={15} xl={15} className="text-center">
                <img src={IMG_IMPORTS.XMAS_BANNER_PROPEL_CORPORATE_GIFTING.URL} alt={IMG_IMPORTS.XMAS_BANNER_PROPEL_CORPORATE_GIFTING.ALT} className="width-9" />
              </Col>
            </Row>
          </Container>
        </section>
      </StyledPropelCorporateGifting>
    );
  }
}

PropelCorporateGifting.propTypes = {
  isHideHeader: bool,
};
PropelCorporateGifting.defaultProps = {
  isHideHeader: false,
};
export default PropelCorporateGifting;




// WEBPACK FOOTER //
// client/containers/Campaigns/PropelCorporateGifting/index.js